/**
 * TFACT 利用マニュアルの URL を組み立てる。
 *
 * マニュアルのホストは環境ごとに異なる（dev は dev.sstf.agest.app）ため、
 * URL 全体をベタ書きせず「ベース URL（env で差し替え）＋ ページのパス（定数）」に分ける。
 * ベース URL はビルド時に焼き込まれるため、docker build の
 * REACT_APP_TFACT_MANUAL_BASE_URL に環境ごとの値を渡すこと。
 */
const DEFAULT_MANUAL_BASE_URL = "https://sstf.agest.app/docs/tfact/manual";

/** マニュアルのベース URL（末尾スラッシュなしに正規化して返す）。 */
export function getManualBaseUrl(
  baseUrl: string | undefined = process.env.REACT_APP_TFACT_MANUAL_BASE_URL,
): string {
  return (baseUrl || DEFAULT_MANUAL_BASE_URL).replace(/\/+$/, "");
}

/**
 * マニュアル内ページのパス。
 *
 * マニュアルは GCS へ静的配信されており拡張子なしの URL は 404 になるため、
 * ページのパスには必ず `.html` を付ける。アンカーは日本語見出しの
 * パーセントエンコード（デコード後の値をコメントに併記）。
 */
export const MANUAL_PATHS = {
  /** テストターゲット管理ツール > メイン画面 */
  targetManagerMain: "/ja/reference/target-manager/01-main.html",
  /** テストターゲット管理ツール > 操作ログのインポート */
  operationLogImport: "/ja/reference/target-manager/04-operation-log.html",
  /** 同上 #操作ログのサイズ削減 */
  operationLogSizeReduction:
    "/ja/reference/target-manager/04-operation-log.html#%E6%93%8D%E4%BD%9C%E3%83%AD%E3%82%B0%E3%81%AE%E3%82%B5%E3%82%A4%E3%82%BA%E5%89%8A%E6%B8%9B",
} as const;

/** マニュアルルートからの絶対パス（先頭 `/`）を完全な URL にする。 */
export function buildManualUrl(path: string, baseUrl?: string): string {
  return `${getManualBaseUrl(baseUrl)}${path}`;
}
